import moment from 'moment';
import { Modal } from '../../../components/Modal';
import { getWaitlistServiceLabel, minutesToTime } from '../Enum';
import { Clock } from 'lucide-react';

interface WaitlistAlertModalProps {
    open: boolean;
    date: Date;
    entries: any[];
    loading?: boolean;
    onClose: () => void;
    onViewAll?: () => void;
}

export default function WaitlistAlertModal({
    open,
    date,
    entries,
    loading = false,
    onClose,
    onViewAll,
}: WaitlistAlertModalProps) {
    if (!open) return null;

    const count = entries?.length || 0;

    return (
        <Modal
            title="Fila de espera"
            subTitle={moment(date).format('DD/MM/YYYY')}
            onClose={onClose}
            desktopClassName="sm:!max-w-xl"
        >
            {loading ? (
                <div className="space-y-2" aria-busy="true">
                    <div className="sf-skeleton h-16" />
                    <div className="sf-skeleton h-16" />
                </div>
            ) : count ? (
                <div className="space-y-3">
                    <h3 className="sf-group-title !pb-0">
                        {count} {count === 1 ? 'cliente aguardando' : 'clientes aguardando'} neste dia
                    </h3>
                    <ul className="sf-group">
                        {entries.map((entry) => (
                            <li key={entry._id}>
                                <div className="sf-row">
                                    <span className="sf-row-body">
                                        <span className="sf-row-title">{entry?.client?.name || 'Cliente'}</span>
                                        <span className="sf-row-sub">{getWaitlistServiceLabel(entry)}</span>
                                        <span className="sf-row-sub">{entry?.attendant?.name || 'Qualquer atendente'}</span>
                                    </span>
                                    <span className="sf-row-sub shrink-0">
                                        {minutesToTime(entry?.timeWindowStartMinutes)} às {minutesToTime(entry?.timeWindowEndMinutes)}
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            ) : (
                <div className="sf-state">
                    <Clock aria-hidden />
                    <h2>Nenhum cliente aguardando neste dia</h2>
                </div>
            )}

            {onViewAll && (
                <div className="mt-4 flex justify-end">
                    <button type="button" className="sf-link" onClick={onViewAll}>
                        Ver fila completa
                    </button>
                </div>
            )}
        </Modal>
    );
}
